import React, { Component } from 'react';
import * as styled from './menu.styled';
import Lottie from '../lottie/lottie';
import hamburgerMenu from '../../static/lottie/hamburger-menu.json';
import $ from 'jquery';

class Menu extends Component {

    constructor() {
        super();
        this.menu = React.createRef();
        this.lottie = React.createRef();
        this.displayed = false;
        this.animationInMotion = false;
        this.menuInMotion = false;
    }

    componentDidCatch(){}

    toggleMenu() {
        if (!this.animationInMotion && !this.menuInMotion) {
            this.animationInMotion = true;
            this.menuInMotion = true;
            this.displayed = !this.displayed;
            this.lottie.current.setDirection(this.displayed ? 1 : -1);
            this.lottie.current.play();

            if (this.displayed) {
                $(this.menu.current)
                    .css('display', 'flex')
                    .animate({opacity: 1}, 500, () => {
                        this.menuInMotion = false;
                    });
            } else {
                $(this.menu.current).animate({opacity: 0}, 500, () => {
                    $(this.menu.current).css('display', 'none');
                    this.menuInMotion = false;
                });
            }
        }
    }

    animationComplete() {
        this.lottie.current.goToAndStop(this.displayed ? 10 : 0, true);
        this.animationInMotion = false;
    }

    render() {
        return (
            <React.Fragment>
                <styled.MenuButton onClick={this.toggleMenu.bind(this)} className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                    <Lottie ref={this.lottie} animation={hamburgerMenu} onComplete={this.animationComplete.bind(this)} />
                </styled.MenuButton>
                <styled.Menu ref={this.menu} style={{display: 'none', opacity: 0}} className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                    <div>
                        <div>
                            <a href="/#portfolio" onClick={this.toggleMenu.bind(this)}>portfolio</a>
                        </div>
                        <div style={{display: 'none'}}>
                            <a href="/#" onClick={this.toggleMenu.bind(this)}>film</a>
                        </div>
                        <div style={{display: 'none'}}>
                            <a href="/#" onClick={this.toggleMenu.bind(this)}>reserved area</a>
                        </div>
                        <div>
                            <a href="/#about" onClick={this.toggleMenu.bind(this)}>about/contact</a>
                        </div>
                        <div>
                            <a href="/shop" onClick={this.toggleMenu.bind(this)}>shop</a>
                        </div>
                    </div>
                </styled.Menu>
            </React.Fragment>
        );
    }
}

export default Menu;
